import React from "react";
import "./Work.css";
import Projects from "./projects/Projects";

const Work = () => {
  return (
    <div className="work-section">
      <div className="work-section-content">
        <h1>Other Work</h1>
        <p>
          Here are a few projects I've worked on. Want to see more? You can find
          them{" "}
          <a
            href="https://talalzeini.github.io/links-tree/"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </p>
      </div>
      <Projects />
    </div>
  );
};

export default Work;
